import React from 'react';
import styles from '../App.module.css';
import { useTranslation } from 'react-i18next';
import { Clock3, ShieldCheck, UsersRound, Wrench } from 'lucide-react';
import { ICON_SIZES, STROKE_WIDTHS } from '../constants/iconSizes';

export default function TrustBadges() {
  const { t } = useTranslation();

  const badges = [
    {
      icon: ShieldCheck,
      title: t('trustBadges.licensed.title'),
      description: t('trustBadges.licensed.desc')
    },
    {
      icon: Wrench,
      title: t('trustBadges.experienced.title'),
      description: t('trustBadges.experienced.desc')
    },
    {
      icon: UsersRound,
      title: t('trustBadges.customers.title'),
      description: t('trustBadges.customers.desc')
    },
    {
      icon: Clock3,
      title: t('trustBadges.response.title'),
      description: t('trustBadges.response.desc')
    }
  ];

  return (
    <section className={`${styles.section} ${styles.trustBadgesSection}`}>
      <div className={styles.trustBadgesContainer}>
        {badges.map((badge, index) => {
          const Icon = badge.icon;
          return (
          <div key={index} className={styles.trustBadge}>
            <div className={styles.trustBadgeIcon}>
              <Icon size={ICON_SIZES.HUGE} strokeWidth={STROKE_WIDTHS.STANDARD} />
            </div>
            <h4>{badge.title}</h4>
            <p>{badge.description}</p>
          </div>
        );
        })}
      </div>
    </section>
  );
}